module.exports = __webpack_public_path__ + "img/sim-fill.f6e2401e.svg";